import type { State } from '@/features/execution/types'

export const ROLES = ['ceo', 'tender', 'pm', 'prep', 'disp', 'site', 'lead', 'tech', 'store', 'hse', 'doc', 'bill', 'acc', 'hr'] as const
export type Role = typeof ROLES[number]
/** Roles held per project (the team); the rest are company-wide. */
export const PROJECT_ROLES = ['pm', 'prep', 'disp', 'site', 'tech', 'doc', 'bill'] as const satisfies readonly Role[]

export interface ItemView { key: string; owner: Role; source: 'auto' | 'manual'; done: boolean; note: string | null; byName: string | null; at: string | null; canTick: boolean }
export interface GateView { to: State; signer: Role; items: ItemView[]; open: number; canSign: boolean }
export interface MemberView { role: Role; userId: string; name: string | null }
export interface ProjectWorkflow {
  projectId: string; state: State | null; derived: boolean
  steps: { state: State; status: 'done' | 'current' | 'next' | 'later' | 'skipped'; since: string | null }[]
  nextGate: GateView | null
  members: MemberView[]
  auSiteManagers: { name: string; crewDays: number; lastDay: string }[]
  signed: { id: number; state: State; at: string; signedRole: string | null; overrideReason: string | null; note: string | null; byName: string | null }[]
  me: { roles: Role[]; projectRoles: Role[]; canManage: boolean; canRecord: State[] }
}
export interface Person { userId: string; name: string | null; roles: Role[] }
export interface InboxRow {
  projectId: string; name: string | null; code: string | null; state: State | null; gate: State; signer: Role
  myItems: string[]; open: number; total: number; canSign: boolean; noProjectManager: boolean
}
